import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from "@angular/router";
import { Observable } from "rxjs";
import { MemberAppDataService } from "../services";
import { MemberType } from "../../shared/enums/data.enums";

@Injectable({
  providedIn: "root"
})
export class MembershipTypeGuard implements CanActivate {
  constructor(
    private router: Router,
    private memberAppDataService: MemberAppDataService
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {    
    let md = this.memberAppDataService.memberAppData ? this.memberAppDataService.memberAppData.membershipDetails : null;
    let memberType = md ? md.memberType : null;
    if (!memberType) {
      this.memberAppDataService.navigateToRoute("membership");
      return false;
    }
    return true;
  }
}
